import React from "react";
import { StyleDate } from "../../../utilities/functions";

const DailySalesDate = ({ row }) => {
  return <div>{row.date ? StyleDate(row?.date) : ""}</div>;
};
export default DailySalesDate;
